// GraveLight — Main JS

// Moon scroll fade
const moon = document.getElementById('moon');
if (moon) {
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    const opacity = Math.max(0, 0.7 - y / 500);
    moon.style.opacity = opacity;
  }, { passive: true });
}

// Custom cursor
const cursor = document.getElementById('cursor');
const ring = document.getElementById('cursorRing');

if (cursor && ring) {
  let mx = 0, my = 0, rx = 0, ry = 0;

  document.addEventListener('mousemove', (e) => {
    mx = e.clientX;
    my = e.clientY;
    cursor.style.left = mx + 'px';
    cursor.style.top = my + 'px';
  });

  function animateRing() {
    rx += (mx - rx) * 0.12;
    ry += (my - ry) * 0.12;
    ring.style.left = rx + 'px';
    ring.style.top = ry + 'px';
    requestAnimationFrame(animateRing);
  }
  animateRing();

  document.querySelectorAll('button, a, .product-card').forEach((el) => {
    el.addEventListener('mouseenter', () => {
      cursor.style.width = '14px';
      cursor.style.height = '14px';
      ring.style.width = '48px';
      ring.style.height = '48px';
      ring.style.borderColor = 'rgba(162,89,247,0.7)';
    });
    el.addEventListener('mouseleave', () => {
      cursor.style.width = '8px';
      cursor.style.height = '8px';
      ring.style.width = '32px';
      ring.style.height = '32px';
      ring.style.borderColor = 'rgba(162,89,247,0.4)';
    });
  });
}

// Mobile menu toggle
const mobileToggle = document.querySelector('.nav-mobile-toggle');
const mobileMenu = document.getElementById('mobile-menu');

if (mobileToggle && mobileMenu) {
  mobileToggle.addEventListener('click', () => {
    const isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
    mobileMenu.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    mobileToggle.setAttribute('aria-expanded', !isOpen);
    mobileToggle.setAttribute('aria-label', isOpen ? 'Menü öffnen' : 'Menü schließen');
  });
}

// Product variant selector
const variantSelect = document.getElementById('variant-select');
const productForm = document.getElementById('product-form');

if (variantSelect && productForm) {
  const optionInputs = productForm.querySelectorAll('.product-page__swatch input');
  optionInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const selectedOptions = [];
      productForm.querySelectorAll('.product-page__option').forEach((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        if (checked) selectedOptions.push(checked.value);
      });
      const optionString = selectedOptions.join(' / ');
      for (const option of variantSelect.options) {
        if (option.text.includes(optionString)) {
          variantSelect.value = option.value;
          break;
        }
      }
    });
  });
}

// Product image gallery
const thumbs = document.querySelectorAll('.product-page__thumb');
const mediaItems = document.querySelectorAll('.product-page__media-item');

thumbs.forEach((thumb) => {
  thumb.addEventListener('click', () => {
    const index = parseInt(thumb.dataset.index, 10);
    thumbs.forEach((t) => t.classList.remove('product-page__thumb--active'));
    thumb.classList.add('product-page__thumb--active');
    mediaItems.forEach((item, i) => {
      item.classList.toggle('product-page__media-item--active', i === index);
      item.style.display = i === index ? 'block' : 'none';
    });
  });
});

mediaItems.forEach((item, i) => {
  if (i > 0) item.style.display = 'none';
});
